import { checkFail, type PresentCheck } from '../core/core.ts';
import type { Json, RecordKey } from './core.ts';

// TODO: Revisit this in light of MapRec.

export function ownKeys<T extends object>(v: T) {
  return Reflect.ownKeys(v) as Array<keyof T>;
}

// Like Partial<T>, except members can be `undefined` for more convenient construction.
// Utilize `pare()` to trim unwanted `undefined`s.
export type Builder<T> = {
  [P in keyof T]?: T[P] | undefined;
};

// Like Record<K, V> but no index signature.
// https://stackoverflow.com/a/59331699/8107589
export type MapRec<K extends RecordKey, V> = { [P in K]: V };

// type RecordEntries<R> = R extends Record<infer K, infer V> ? [K, V] : never;

// // Like `Object.entries`, but with a more accurate tuple type and supports symbol keys.
// // TODO: Create alias for Partial<Record<T>>?
// // TODO!: Test
// // Note: Using Readonly<Partial<Record<K, V>>> makes some callers have nicer return types, but other
// // callers break. I don't fully understand, and it didn't seem like overloads could fix it.
// export function recordEntries<R>(record: R, allKeys = false): RecordEntries<R>[] {
//   // return Object.entries(record);
//   const keyFn = allKeys ? Reflect.ownKeys : Object.keys;
//   return keyFn(record as object).map(
//     (k) => [k, record[k as keyof typeof record]] as RecordEntries<R>
//   );
// }

// Like `Object.entries`, but with a more accurate tuple type and supports symbol keys.
// TODO: Create alias for Partial<Record<T>>?
// TODO!: Test
// Note: Using Readonly<Partial<Record<K, V>>> makes some callers have nicer return types, but other
// callers break. I don't fully understand, and it didn't seem like overloads could fix it.
export function recordEntries<K extends string, V>(
  // record: Record<K, V>,
  record: Partial<Record<K, V>> | Record<K, V>,
  allKeys?: false,
): Array<[K, V]>;
export function recordEntries<K extends RecordKey, V>(
  // record: Record<K, V>,
  record: Partial<Record<K, V>> | Record<K, V>,
  allKeys: true,
): Array<[K, V]>;
export function recordEntries<K extends RecordKey, V>(
  // record: Record<K, V>,
  record: Partial<Record<K, V>> | Record<K, V>,
  allKeys = false,
): Array<[K, V]> {
  const keyFn = allKeys ? Reflect.ownKeys : Object.keys;
  return keyFn(record).map((k) => [k as K, record[k as K] as V]);
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const recordKeys = ownKeys;

export function recordValues<K extends RecordKey, V>(
  // record: Record<K, V>,
  record: Partial<Record<K, V>> | Record<K, V>,
  allKeys = false,
): V[] {
  const keyFn = allKeys ? Reflect.ownKeys : Object.keys;
  return keyFn(record).map((k) => record[k as K] as V);
}

// type RecordEntries<R> = R extends Partial<Record<infer K, infer V>> ? [K, V] : never;

// // Like `Object.entries`, but with a more accurate tuple type and supports symbol keys.
// // TODO: Create alias for Partial<Record<T>>?
// // TODO!: Test
// // Note: Using Readonly<Partial<Record<K, V>>> makes some callers have nicer return types, but other
// // callers break. I don't fully understand, and it didn't seem like overloads could fix it.
// export function recordEntries<R extends Partial<Record<RecordKey, unknown>>>(
//   record: R,
//   allKeys = false
// ) {
//   const keyFn = allKeys ? Reflect.ownKeys : Object.keys;
//   return keyFn(record).map((k) => [k, record[k]] as RecordEntries<R>);
// }

// https://stackoverflow.com/a/60822641/8107589
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ReturnTypeWithArgs<T extends (...args: any[]) => any, ArgsT> = Extract<
  T extends {
    (...args: infer A1): infer R1;
    (...args: infer A2): infer R2;
    (...args: infer A3): infer R3;
    (...args: infer A4): infer R4;
  }
    ? [A1, R1] | [A2, R2] | [A3, R3] | [A4, R4]
    : T extends {
          (...args: infer A1): infer R1;
          (...args: infer A2): infer R2;
          (...args: infer A3): infer R3;
        }
      ? [A1, R1] | [A2, R2] | [A3, R3]
      : T extends { (...args: infer A1): infer R1; (...args: infer A2): infer R2 }
        ? [A1, R1] | [A2, R2]
        : T extends { (...args: infer A1): infer R1 }
          ? [A1, R1]
          : never,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ArgsT, any]
>[1];

// TODO: Better name.
export type FullPartial<T> = {
  [P in keyof T]?: T[P] | undefined;
};

export type Nullable<T> = {
  [P in keyof T]?: T[P] | null | undefined;
};

export function parseJson(value: string): Json | undefined;
export function parseJson(value: string, check: typeof PresentCheck): Json;
export function parseJson(value: string, check?: typeof PresentCheck) {
  try {
    return JSON.parse(value);
  } catch (err) {
    if (check) {
      checkFail('parseJson failed.', () => String(err));
    } else {
      console.error('parseJson', err);
    }
    return undefined;
  }
}
